import { render, staticRenderFns } from "./headerA.vue?vue&type=template&id=62274972&scoped=true&"
import script from "./headerA.vue?vue&type=script&lang=js&"
export * from "./headerA.vue?vue&type=script&lang=js&"
import style0 from "./headerA.vue?vue&type=style&index=0&id=62274972&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62274972",
  null
  
)

export default component.exports